import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import createSagaMiddleware from "redux-saga"
import { createBrowserHistory } from 'history'
import { connectRouter, routerMiddleware } from 'connected-react-router'

import rootReducer from './reducers'
import { rootSaga } from "./sagas";

const composeEnhancers = process.env.NODE_ENV === 'development' 
  && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const history = createBrowserHistory()
const routerRootReducer = connectRouter(history)(rootReducer)

const sagaMiddleware = createSagaMiddleware()

const rootStore = createStore(
  routerRootReducer,
  composeEnhancers(applyMiddleware(thunk, sagaMiddleware, routerMiddleware(history))),
)

sagaMiddleware.run(rootSaga);

export {
  rootStore,
  history
}


// WEBPACK FOOTER //
// ./src/reduxModules/configureStore.js